import React, { useState } from "react";
import {
  Box,
  ButtonWithAction,
  CloseIcon,
  Cluster,
  Stack,
  Title,
  constants
} from "@thecb/components";
import AlertBar from "/components/alert-bar";
import Slider, { SliderPosition } from "/components/slider";
import { SliderCloseButton } from "/components/slider/Slider";
import SliderPanel from "/components/slider-panel";
import InlineBillingAddressSection from "./InlineBillingAddressSection";
import { CREDIT_CARD_KIND } from "../../Profile.state";

const { WHITE, CHARADE_GREY } = constants.colors;

const BillingAddressSlider = ({
  isOpen,
  isMobile,
  onClose,
  onAddAddress,
  addressForm,
  addressFormActions,
  showErrors = false,
  addressAlertBar,
  addressAlertBarActions,
  paymentMethod = null,
  paymentMethodJustAdded = false
}) => {
  const [paymentSuccessDismissed, setPaymentSuccessDismissed] = useState(false);

  const paymentAlertText =
    paymentMethod?.kind === CREDIT_CARD_KIND
      ? `Card ending in ${paymentMethod.lastFour} has been added to your wallet`
      : `Account ending in ${paymentMethod?.lastFour} has been added to your wallet`;

  return (
    <Slider
      isOpen={isOpen}
      isMobile={isMobile}
      position={SliderPosition.DOCUMENT_TOP}
      closeSlider={onClose}
      ariaLabelledBy="billing-address-slider-title"
    >
      {!isMobile && (
        <SliderCloseButton
          closeAction={onClose}
          ariaLabel="Close Billing Address Slider"
        />
      )}
      <SliderPanel status="onScreen" sliderKey="billing-address-panel">
        <Box
          padding="0"
          minWidth="100%"
          minHeight="100%"
          extraStyles="display: flex; flex-direction: column; height: 100%;"
        >
          <Box
            background={CHARADE_GREY}
            padding="1.5rem"
            extraStyles={`
            position: sticky;
            top: 0;
            z-index: 10;
          `}
          >
            <Cluster
              justify="space-between"
              align="center"
              extraStyles="overflow: visible;"
            >
              <Title
                id="billing-address-slider-title"
                color={WHITE}
                variant="small"
                as="h2"
              >
                Set Up Autopay
              </Title>
              {isMobile && (
                <ButtonWithAction
                  variant="smallGhost"
                  contentOverride
                  action={onClose}
                  dataQa="close-billing-address-slider"
                  aria-label="Close"
                  extraStyles={`
                  padding: 0.15rem;
                  min-width: 1.5rem;
                  min-height: auto;
                  margin: 0;
                  svg { height: 12px; width: 12px; }
                `}
                >
                  <CloseIcon
                    iconFill={WHITE}
                    iconWidth="12px"
                    iconHeight="12px"
                    aria-hidden="true"
                  />
                </ButtonWithAction>
              )}
            </Cluster>
          </Box>
          <Box
            background={WHITE}
            padding="0 1.5rem"
            extraStyles="overflow-y: auto; flex: 1; min-height: 0;"
          >
            <Box padding="1.5rem 0 0">
              <Stack childGap="1.5rem">
                {paymentMethodJustAdded && !paymentSuccessDismissed && (
                  <AlertBar
                    alerts={[{ heading: paymentAlertText, variant: "success" }]}
                    deleteAlert={() => setPaymentSuccessDismissed(true)}
                  />
                )}
                {addressAlertBar?.alerts?.length > 0 && (
                  <AlertBar {...addressAlertBar} {...addressAlertBarActions} />
                )}
                <InlineBillingAddressSection
                  addressForm={addressForm}
                  addressFormActions={addressFormActions}
                  showErrors={showErrors}
                />
              </Stack>
            </Box>
            <Box padding="1.5rem 0 1.5rem">
              <ButtonWithAction
                text="Add Address"
                variant="primary"
                action={onAddAddress}
                dataQa="Add Address"
                borderRadius="10px"
                extraStyles="width: 100%; margin: 0;"
              />
            </Box>
          </Box>
        </Box>
      </SliderPanel>
    </Slider>
  );
};

export default BillingAddressSlider;
